import { connect } from 'react-redux';

import AdminShipmentComponent from './admin-shipment.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminShipmentComponent);



// WEBPACK FOOTER //
// ./src/components/admin/shipment/admin-shipment.ts